import { render, staticRenderFns } from "./searchGame.vue?vue&type=template&id=c0ffb62a&scoped=true"
import script from "./searchGame.vue?vue&type=script&lang=js"
export * from "./searchGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ffb62a",
  null
  
)

export default component.exports